import { DesignationService } from './../../../_services/designation.service';
import { ToastrService } from 'ngx-toastr';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DepartmentService } from '../../../_services/department.service';
import { UnitService } from '../../../_services/unit.service';
import { GlobalService } from '../../../_services/global.service';
import { DivisionService } from '../../../_services/division.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ResponseStructure } from '@iq-central-front-end/share';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-setting-structure',
  templateUrl: './setting-structure.component.html',
  styleUrls: ['./setting-structure.component.scss'],
})
export class SettingStructureComponent implements OnInit, OnDestroy {
  divisionCloseModal: ElementRef;
  departmentForm;
  departments: any[] = [];
  divisions: any[] = [];
  designations: any[] = [];
  units: any[] = [];
  divisionForm: UntypedFormGroup;
  designationForm;
  unitForm: UntypedFormGroup;
  isDeleting: boolean = false;

  selectedDepartment: any;
  selectedDesignation: any;

  sub: Subscription = new Subscription();
  profiles;
  constructor(
    private _department: DepartmentService,
    private _unit: UnitService,
    private _global: GlobalService,
    private _division: DivisionService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private _toastr: ToastrService,
    private _designation: DesignationService
  ) { }

  ngOnInit(): void {
    this.getResolvedData();
    this.initDivisionForm();
    this.initUnitForm();
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.departments = res['resolvedData'].allDepartments['responseResult'];
        console.log(this.departments.length);
        this.divisions = res['resolvedData'].allDivisions['responseResult'];
        this.designations =
          res['resolvedData'].allDesignations['responseResult'];
        this.units = res['resolvedData'].allUnits['responseResult'];
      })
    );
  }

  initDivisionForm(division?: any) {
    this.divisionForm = this.fb.group({
      departmentId: [division?.id ?? '', Validators.required],
      nameOnlyRequestDTOS: [division?.name ?? ''],
    });
  }

  initUnitForm(unit?: any) {
    this.unitForm = this.fb.group({
      divisionId: [unit?.id ?? '', Validators.required],
      nameOnlyRequestDTOS: [unit?.name ?? ''],
    });
  }

  addDepartment() {
    this._global.showSpinner();

    let payload: any = { name: this.departmentForm };

    let observable;
    if (this.selectedDepartment) {
      observable = this._department.updateDepartment(
        this.selectedDepartment.id,
        payload
      );
    } else {
      observable = this._department.createDepartment([payload]);
    }

    observable.subscribe({
      next: (res: ResponseStructure) => {
        if (this.selectedDepartment) {
          const indexToReplace = this.departments.findIndex(
            (dept) => dept.id === this.selectedDepartment.id
          );
          if (indexToReplace !== -1) {
            this.departments[indexToReplace] = res.responseResult;
          }
        } else {
          this.departments.push(res.responseResult[0]);
        }

        this.departmentForm = '';
        this._global.successHandlerWithObject(res);
      },
      error: (err) => {
        this._global.hideSpinner();
      },
      complete: () => {
        this._global.hideSpinner();
      },
    });
  }

  editDepartment(department: any) {
    this.selectedDepartment = department;
    this.departmentForm = this.selectedDepartment.name;
  }

  addDesignation() {
    this._global.showSpinner();

    let payload: any = { name: this.designationForm };

    let observable;
    if (this.selectedDesignation) {
      observable = this._designation.updateDesignation(
        this.selectedDesignation.id,
        payload
      );
    } else {
      observable = this._designation.createDesignation([payload]);
    }

    observable.subscribe({
      next: (res: ResponseStructure) => {
        if (this.selectedDesignation) {
          const indexToReplace = this.designations.findIndex(
            (designation) => designation.id === this.selectedDesignation.id
          );
          if (indexToReplace !== -1) {
            this.designations[indexToReplace] = res.responseResult;
          }
        } else {
          this.designations.push(res.responseResult[0]);
        }

        this.designationForm = '';
        this._global.successHandlerWithObject(res);
      },

      error: (err) => {
        this.designationForm = '';
        this._global.hideSpinner();
      },
      complete: () => {
        this.designationForm = '';
        this._global.hideSpinner();
      },
    });
  }

  editDesignation(designation: any) {
    this.selectedDesignation = designation;
    this.designationForm = this.selectedDesignation.name;
  }

  addDivision() {
    this._global.showSpinner();
    const payload = this.divisionForm.value;
    const nameOnlyRequestDTOS = [{ name: payload.nameOnlyRequestDTOS }];
    const departmentId = payload.departmentId;
    this._division.createDivision(nameOnlyRequestDTOS, departmentId).subscribe({
      next: (res: ResponseStructure) => {
        this.divisionForm.reset();

        this.divisions.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }

  editDivision(division: any) {
    this.initDivisionForm(division);
  }

  addUnit() {
    this._global.showSpinner();
    const payload = this.unitForm.value;
    const nameOnlyRequestDTOS = [{ name: payload.nameOnlyRequestDTOS }];
    const divisionId = payload.divisionId;
    this._unit.createUnit(nameOnlyRequestDTOS, divisionId).subscribe({
      next: (res: ResponseStructure) => {
        this.unitForm.reset();

        this.units.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }

  deleteDepartment(department) {
    this.isDeleting = true;

    this._department.deleteDepartment(department.id).subscribe({
      next: (res: ResponseStructure) => {
        this.isDeleting = false;
        this.departments = this.departments.filter(
          (d) => d.id !== department.id
        );
        this._global.globalSuccessHandler(res);
      },
    });
  }

  deleteDesignation(designation) {
    this.isDeleting = true;

    this._designation.deleteDesignation(designation.id).subscribe({
      next: (res: ResponseStructure) => {
        this.isDeleting = false;

        this.designations = this.designations.filter(
          (d) => d.id != designation.id
        );
        this._global.globalSuccessHandler(res);
      },
    });
  }

  deleteDivision(division) {
    this.isDeleting = true;

    this._division.deleteDivision(division.id).subscribe({
      next: (res: ResponseStructure) => {
        this.isDeleting = false;

        this.divisions = this.divisions.filter((d) => d.id != division.id);
        this._global.globalSuccessHandler(res);
      },
    });
  }

  deleteUnit(unit) {
    this.isDeleting = true;

    this._unit.deleteUnit(unit.id).subscribe({
      next: (res: ResponseStructure) => {
        this.isDeleting = false;

        this.units = this.units.filter((d) => d.id != unit.id);
        this._global.globalSuccessHandler(res);
      },
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
